/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Export_FailedInputs */

const en_toast_export_failed = /** @type {(inputs: Toast_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export failed`)
};

const de_toast_export_failed = /** @type {(inputs: Toast_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Export failed" |
*
* @param {Toast_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_export_failed = /** @type {((inputs?: Toast_Export_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Export_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_export_failed(inputs)
	return de_toast_export_failed(inputs)
});